import React from "react";
import Salary from "../Components/Salary";

function SalaryPage() {
  return (
    <div className="bg-gradient-to-r from-blue-300 to-blue-400">
      <Salary />
    </div>
  );
}

export default SalaryPage;
